import React, { useEffect, useState } from 'react'
import { getImages } from './const'

const Footer = () => {
    const [isMobile, setIsMobile] = useState(false);
    const handleResize = () => {
        setIsMobile(window.innerWidth < 768);
    };
    useEffect(() => {
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
  return (
    <>
      
        <footer className='footer-wrap'>
          <div className='container'>
            <div className='d-md-flex align-items-end justify-content-between footer-block'>
              <div className='pe-md-4'>
                <div className='fb-logo mb-3'>
                  <img src={getImages('Mercedes-Showroom-logo.png')}/>
                </div>
                <div className='ft-xs-title mb-3'>
                  Mon - Fri: 10am to 5pm <br/>
                  Saturday: 10am to 2pm <br/>
                  Sunday: Closed 
                </div>
                <div className='ft-xs-title mb-3'>51 & 61 SW 5th Court Pompano Beach, FL 33060</div>
                <div className='fb-contact-info'>
                  <a href='tel:9549463000'>(954) 946-3000</a><br/>
                </div>
              </div>
              <div>
                {/* <ul className='footer-menu'>
                  <li>
                    <a href='#'><span className='social-icon'><img src={getImages('ico-facebook.svg')}/></span> <span className='d-none d-md-inline-block'>Facebook</span></a>
                  </li>
                  <li>
                    <a href='#'><span className='social-icon'><img src={getImages('ico-twitter.svg')}/></span> <span className='d-none d-md-inline-block'>Twtiter</span></a>
                  </li>
                  <li>
                    <a href='#'><span className='social-icon'><img src={getImages('ico-instagram.svg')}/></span> <span className='d-none d-md-inline-block'>Instagram</span></a>
                  </li>
                </ul> */}
                <div className='mt-4 mb-3 powered-by text-md-end'>
                  {isMobile ? 
                    <a href='https://greenlightautomotivesolutions.com/' target='_blank'><img src={getImages('gas-horz.svg')}/></a>
                    :
                    <a href='https://greenlightautomotivesolutions.com/' target='_blank'><img src={getImages('gas-vert.svg')}/></a>
                  }
                </div>
              </div>
            </div>
          </div>
        </footer>
    </>
  )
}

export default Footer